import { Close as CloseRoundedIcon } from "@material-ui/icons";
import { Menu as MenuOutlinedIcon } from "@material-ui/icons";
import { useForm, ValidationError } from "@formspree/react";
import { formspree_url } from "../../API/constants";
import Footer from "../../components/Footer/Footer";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Contact.css";

function Contact() {
  const [state, handleSubmit] = useForm(formspree_url);

  const [isMobile, setIsMobile] = useState(false);

  if (state.succeeded) {
    return (
      <p
        style={{
          color: "white",
          fontSize: "22px",
          backgroundColor: "#ca9b56",
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Thanks for reaching out!
        <br />
        <br /> We'll get back to you soon.
        <br />
        <br />
        <Link to="/">
          <button className="subbutton">Return</button>
        </Link>
      </p>
    );
  }

  return (
    <div className="Contact">
      <nav className="navbar-contact">
        <ul
          className={
            isMobile ? "nav-links-mobile-contact" : "nav-links-contact"
          }
          onClick={() => setIsMobile(false)}
        >
          <Link to="/" className="home-contact">
            <li>Home</li>
          </Link>
          <Link to="/calendar" className="calendar-contact">
            <li>Calendar</li>
          </Link>
          <Link to="/contact" className="contact-contact">
            <li>Contact</li>
          </Link>
          <Link to="/donation" className="donation-contact">
            <li>Donation</li>
          </Link>
        </ul>
        <button
          className="mobile-menu-icon-contact"
          onClick={() => setIsMobile(!isMobile)}
        >
          {isMobile ? (
            <CloseRoundedIcon fontSize="large" />
          ) : (
            <MenuOutlinedIcon fontSize="large" />
          )}
        </button>
      </nav>
      <Link to="/">
        <div className="logo-home">
          <div className="logoItems">
            <img src="assets/logo.png" alt="" />
            <p>
              <strong>Claremont</strong> <br /> Main Road Mosque
            </p>
          </div>
        </div>
      </Link>
      <div className="mainStuff">
        <div className="containers">
          <div className="right-contact">
            <h1>General Info</h1>
            <hr />
            <br />
            <h3>42 Main Rd, Claremont, Cape Town, 7708</h3>
            <br />
            <h3>021 683 8384</h3>
            <br />
            <h3>cmrm@iafrica.co.za</h3>
            <br />
            <br />
            <br /> <br /> <br />
            <h2>Masjid Admin</h2>
            <hr />
            <br />
            <h4>Sharifa Wydeman</h4>
            <br />
            <h4>021 683 8384</h4>
            <br />
            <h4>cmrm@iafrica.co.za</h4>
            <br />
            <br />
            <br />
            <h2>Board Secretary</h2>
            <hr />
            <br />
            <h4>Jaamia Galant</h4>
            <br />
            <h4>079 231 4273</h4>
            <br />
            <h4>jaamia@googlemail.com</h4>
            <br />
            <br />
            <br />
            <h2>Bank Info</h2>
            <hr />
            <br />
            <h4>First National Bank</h4>
            <br />
            <h4>502 504 469 93</h4>
            <br />
            <h4>204209</h4>
            <br />
            <br />
            <div className="left-contact">
            <br />
            <h1>Get in Touch</h1>
            <form onSubmit={handleSubmit}>
              <label>Full Name:</label>
              <br />
              <input id="fullName" type="fullName" name="fullName" required />
              <br />
              <br />
              <label htmlFor="email">Email Address:</label>
              <br />
              <input id="email" type="email" name="email" required />
              <br />
              <br />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />
              <label>Your Message:</label>
              <br />
              <br />
              <textarea id="message" name="message" required />
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />
              <br />
              <br />
              <button type="submit" disabled={state.submitting}>
                Submit
              </button>
            </form>
          </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
